import { styled } from 'linaria/react';

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--space-350);
  width: 60%;

  @media (--only-mobile) {
    gap: var(--space-400);
    width: 100%;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--space-300) var(--space-400) var(--space-200) var(--space-400);

  @media (--only-mobile) {
    padding: var(--space-200);
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  gap: 11%;
  margin-top: var(--space-400);

  @media (--only-tablet) {
    gap: var(--space-500);
    margin-top: var(--space-300);
  }

  @media (--to-tablet) {
    flex-direction: column;
    gap: var(--space-400);
  }
`;

export const SkeletonContainer = styled.div`
  width: 29%;
  height: 226px;
  padding-top: var(--space-475);

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const RoomsContainerRow = styled.div`
  width: 100%;
  margin-top: var(--space-300);
  /* Отрицательный отступ нужен, чтобы нивелировать отступ к дочерних элементов */
  margin-bottom: -12px;

  @media (--only-tablet) {
    margin-bottom: -4px;
  }

  @media (--only-mobile) {
    margin-top: var(--space-200);
  }
`;

export const FooterContainer = styled.div`
  @media (--to-tablet) {
    margin-top: auto;
  }
  @media (--only-mobile) {
    position: fixed;
    bottom: var(--space-200);
    z-index: 999;
    width: calc(100% - var(--space-400));
  }
`;

export const FooterWrapper = styled.div`
  position: relative;
  margin-top: var(--space-500);
`;

export const MeasurementBannerWrapper = styled.div`
  @media (--only-mobile) {
    margin-bottom: var(--space-1000);
  }
`;
